import { useMemo, useState } from 'react';

import { useDebouncedValue } from '@tanstack/react-pacer/debouncer';
import { useQuery } from '@tanstack/react-query';

import { clientSearchOptions } from '@/entities/client';

import { CLIENT_SEARCH_DEBOUNCE_MS, CLIENT_SEARCH_PAGE_SIZE } from '../config/search';
import { sortClientsBySearchTerm } from '../lib/sort-clients';

export function useClientSearch() {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm] = useDebouncedValue(searchTerm, {
        wait: CLIENT_SEARCH_DEBOUNCE_MS,
    });

    const effectiveSearchTerm = debouncedSearchTerm.trim().toLowerCase();

    const { data, isFetching, isError } = useQuery(
        clientSearchOptions(
            effectiveSearchTerm,
            effectiveSearchTerm.length > 0,
            CLIENT_SEARCH_PAGE_SIZE,
        ),
    );

    const clients = useMemo(
        () => sortClientsBySearchTerm(data?.items ?? [], searchTerm),
        [data, searchTerm],
    );

    return {
        searchTerm,
        setSearchTerm,
        debouncedSearchTerm,
        clients,
        hasData: data !== undefined,
        isError,
        isFetching,
    };
}
